import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormGroup } from 'react-bootstrap';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

import messages from '../../locale/jsonMessages';
import updateStep3 from './updateStep3';
import { getDynamicName } from '../../helpers/GetDynamicItemName/getDynamicName';

import tickIcon from '/public/SiteIcons/rulesIcon.svg';
import locationIcon from '/public/SiteIcons/locationIdea.svg';

import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';

class ReviewGuestBook extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      reviewGuestBook: [],
      isDisabled: true,
    };
  }

  componentDidMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({ reviewGuestBook: listingFields.reviewGuestBook });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
    if (listingFields != undefined) {
      this.setState({ reviewGuestBook: listingFields.reviewGuestBook });
    }
  }

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step, locale, dynamicLanguageData } = this.props;
    const { reviewGuestBook, isDisabled } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.guestRequirementsTitle)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <h3 className={cx(cs.commonContentText, cs.spaceBottom3)}><FormattedMessage {...messages.stepThreeRules} /></h3>
            <p className={cx(cs.commonMediumText, cs.spaceBottom3)}><span><FormattedMessage {...messages.reviewGuestBookDescription} /></span></p>
            <FormGroup className={s.formGroup}>
              <ul className={cx('list-unstyled', s.noPadding, s.noMargin, s.unorderedList)}>
                {
                  reviewGuestBook.map((item, key) => {
                    if (item.isEnable === "1") {
                      let dynamicName = getDynamicName({ value: item, locale, data: dynamicLanguageData });
                      return (
                        <li key={key} className={cx(s.reviewGuestFlex, cs.spaceBottom3)}>
                          <span className={cx(cs.commonMediumText)}><img src={tickIcon} className={cx(s.checkIcon, 'reviewTickRTL')} /></span>
                          <span className={cx(cs.commonMediumText)}> {dynamicName?.itemName || item.itemName} </span>
                        </li>
                      )
                    }
                  })
                }
              </ul>
              <div className={cx(s.searchToolTip, cs.spaceBottom3)}>
                <img src={locationIcon} className={'listTipIcon'} />
                <span className={cx(s.locationTipCss, cs.commonMediumText)}><FormattedMessage {...messages.reviewGuestBookNote} /></span>
              </div>
            </FormGroup>
          </div>
          <FooterButton
            isDisabled={isDisabled}
            nextPage={nextPage}
            previousPage={previousPage}
            previousPagePath={"booking-scenarios"}
            nextPagePath={"local-laws"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>

    );
  }
}

ReviewGuestBook = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: updateStep3
})(ReviewGuestBook);

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data
});

const mapDispatch = {};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ReviewGuestBook)));
